import React, { useCallback, useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";

import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";

import { deleteSysPromptsAPI } from "Api/sysPromptsAPI";
import DeleteModal from "components/DeleteModal/DeleteModal";
import CreateOrUpdateSysPromptsModal from "../create-or-update-sysPrompts-modal/createOrUpdateSysPromptsModal";
import { consoleLog } from "helpers";

const EditOrDeleteSysPrompt = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const {
    setSysPromptsFormData,

    initialSysPromptsFormState,

    setFetchSysPrompts,
    setIsOpenSystemPromptsPreviewModal,
  } = useGlobalContext();

  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    const response = await deleteSysPromptsAPI(
      {
        id: props.cell.row.original.id,
      },
      () => {},
      token
    );
    if (response) {
      toast.success(`System prompt deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchSysPrompts(true);
    }

    if (!response) {
      toast.error("System Prompt deletion failed");
    }

    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    setIsFormOpen(true);

    setSysPromptsFormData(
      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
            isActive: props.cell.row.original?.isActive ? "active" : "inactive",
          }
        : {
            ...initialSysPromptsFormState,
            isActive: initialSysPromptsFormState?.isActive
              ? "active"
              : "inactive",
          }
    );
    consoleLog([props, "props"]);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
  };

  const handleFormSubmit = (formData) => {
    consoleLog(["Form submitted:", formData]);
  };

  const handleOpenPreviewModal = useCallback(() => {
    setSysPromptsFormData(
      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
            isActive: props.cell.row.original?.isActive ? "active" : "inactive",
          }
        : {
            ...initialSysPromptsFormState,
            isActive: initialSysPromptsFormState?.isActive
              ? "active"
              : "inactive",
          }
    );
    setIsOpenSystemPromptsPreviewModal(true);
  }, [
    initialSysPromptsFormState,
    props.cell.row.original,
    setIsOpenSystemPromptsPreviewModal,
    setSysPromptsFormData,
  ]);
consoleLog([handleOpenPreviewModal])
  return (
    <div className="flex gap-4">
      <BsPen
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleDeleteClick}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />

      <CreateOrUpdateSysPromptsModal
        isOpen={isFormOpen}
        onClose={handleFormClose}
        onSubmit={handleFormSubmit}
        isEditMode={true}
        promptFragmentsData={props?.promptFragmentsData}
      />
    </div>
  );
};

export default EditOrDeleteSysPrompt;
